<script lang="ts">

</script>
<div class="text-center alert-secondary">
    <div class="spinner-grow spinner-grow-sm"></div> Downloading!
</div>
